<template>
    <table class="w-full whitespace-no-wrap">
        <thead class="cursor-pointer">
        <tr @click="expanded = !expanded" class="text-md font-bold tracking-wide text-center text-gray-700 border-b dark:border-gray-700 bg-gray-200 dark:text-gray-200 dark:bg-gray-700">
            <th class="px-4 py-3 w-3/5 text-left">
                <h4 class="text-xl font-bold whitespace-normal">{{ surveyScores.name }}</h4>
            </th>
            <th class="px-4 py-3">
                <div class="flex items-center w-full justify-start">
                    <p class="text-xl">Average Score: {{ surveyScores.avgScore }}</p>
                    <span class="inline-block ml-4 px-2 py-1 font-semibold leading-tight text-lg rounded-full"
                          :style="{
                               backgroundColor: surveyScores.scoreRatingDetails.bg_color,
                               color: surveyScores.scoreRatingDetails.text_color
                          }"
                    >
                        {{ surveyScores.scoreRatingDetails.label }}
                    </span>
                </div>
            </th>
            <th class="px-4 py-3">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 9l-7 7-7-7"></path>
                </svg>
            </th>
        </tr>
        </thead>
        <tbody v-show="expanded" class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-center">
        <tr v-for="(sectionScores,sectionIndex) in surveyScores.sections"
            :key="'sectionScore-' + sectionIndex"
            class="text-gray-700 dark:text-gray-400">
            <td class="px-4 py-3 w-3/5 text-sm text-left whitespace-normal">
                <h4 class="text-lg font-semibold">{{ sectionScores.name }}</h4>
            </td>
            <td class="px-4 py-3">
                <div class="flex items-center w-full justify-left text-sm">
                    <p>Average Score: {{ sectionScores.avgScore }}</p>
                    <span class="inline-block ml-3 px-2 py-1 font-semibold leading-tight rounded-full"
                          :style="{
                               backgroundColor: sectionScores.scoreRatingDetails.bg_color,
                               color: sectionScores.scoreRatingDetails.text_color
                          }"
                    >
                        {{ sectionScores.scoreRatingDetails.label }}
                    </span>
                </div>
            </td>
            <td class="px-4 py-3"></td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import {ref} from "vue";
import Pill from "@/Jetstream/Pill";

export default {
    name: "SurveyScoreExplorer",
    components: {
        Pill
    },
    props: {
        surveyScores: {
            type: Object,
            required: true,
        }
    },
    setup() {
        const expanded = ref(false);

        return {
            expanded,
        }
    }
}
</script>

<style scoped>

</style>
